import styled from 'styled-components';

import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';
import { Page } from 'layout/styles/PageLayout.style';

export const PageWrapper = styled(Page)`
  background-color: ${colours.neutral[100]};
  gap: 0;

  @media (max-width: ${breakpoints.tablet}) {
    padding: 80px 0 0;
  }
`;

export const Container = styled('div')`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0 auto;
  max-width: 600px;
  padding: 15px 15px 120px;
  width: 100%;

  @media (max-width: ${breakpoints.tablet}) {
    max-width: none;
    padding: 5px 15px 120px;
  }
`;

export const TitleRow = styled('div')`
  align-items: center;
  display: flex;
  padding: 10px 0;
  width: 100%;
`;
